var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGestiones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188,
    height: 53,
    viewBox: "0 0 188 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.412,
    y1: 0.079,
    x2: 0.813,
    y2: 1.419,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff6e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ff5f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff4900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ff3c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M27.919.243A1.054,1.054,0,0,0,26.864,1.3V16.275a6.094,6.094,0,0,1-.952,3.672,3.2,3.2,0,0,1-2.742,1.286,3.355,3.355,0,0,1-2.8-1.286,5.842,5.842,0,0,1-1.007-3.672l-.035-7.8A1.054,1.054,0,0,0,18.275,7.42H14.484a1.054,1.054,0,0,0-1.055,1.051l-.035,7.8a5.841,5.841,0,0,1-1.008,3.672,3.335,3.335,0,0,1-2.779,1.286,3.183,3.183,0,0,1-2.724-1.286,6.094,6.094,0,0,1-.951-3.672V11.989a1.054,1.054,0,0,0-1.055-1.054H1.2A1.054,1.054,0,0,0,.149,11.989v4.286q0,4.921,2.407,7.624a8.662,8.662,0,0,0,6.828,2.7,8.182,8.182,0,0,0,6.266-2.621,1,1,0,0,1,1.453,0,8.06,8.06,0,0,0,2.318,1.708,8.919,8.919,0,0,0,4.011.914,8.641,8.641,0,0,0,6.81-2.7q2.406-2.7,2.407-7.624V1.3A1.054,1.054,0,0,0,31.593.243Z",
    transform: "translate(-0.149 -0.243)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_45",
    "data-name": "Rect\\xE1ngulo 45",
    width: 32.531,
    height: 26.412,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_578",
    "data-name": "Grupo 578",
    transform: "translate(-4182 -4257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577",
    transform: "translate(4182 4257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    "data-name": "Trazado 105",
    d: "M26.5,0A26.5,26.5,0,1,1,0,26.5,26.5,26.5,0,0,1,26.5,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Isotipo_Solid_Color",
    "data-name": "Isotipo Solid Color",
    transform: "translate(10 13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    transform: "translate(0.032 0.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_44",
    "data-name": "Rect\\xE1ngulo 44",
    width: 39.628,
    height: 35.986,
    transform: "matrix(0.938, -0.346, 0.346, 0.938, -8.569, 3.16)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_171",
    "data-name": "Grupo 171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M5.787,74.028a2.893,2.893,0,1,1-2.893-2.893,2.893,2.893,0,0,1,2.893,2.893",
    transform: "translate(0 -67.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M275.121,2.893A2.893,2.893,0,1,1,272.227,0a2.893,2.893,0,0,1,2.893,2.893",
    transform: "translate(-255.975)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_36",
    "data-name": "L\\xEDnea 36",
    y2: 28.217,
    transform: "translate(4246.387 4270.596)",
    fill: "none",
    stroke: "#ff6f00",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "GESTIONES",
    transform: "translate(4258 4290)",
    fill: "#efefef",
    fontSize: 20,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.021em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GESTIONES")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestiones);
export default __webpack_public_path__ + "static/media/Gestiones.84dc842b91702ca123dcda4ae41c7aee.svg";
export { ForwardRef as ReactComponent };